import { PendingSuspensionItem} from "./PendingSuspensionItem";

export default PendingSuspensionItem;
